<template>
    <div class="relative rd-8 min-h-100 w-full bg-#191D23" @mouseenter="playVideo('play')" @mouseleave="playVideo('pause')" ref="gridInstance">
        <LoadingComponent :loading="loading" :words="loadingWords" :isLoadingError="isLoadingError" />
        <img
            @contextmenu="preventEvent($event)"
            v-if="type === 'img' && src"
            ref="imgInstance"
            :src="src"
            alt=""
            class="w-full h-full transform-scale-0 absolute left-0 top-0 rounded-8px"
        />
        <!-- muted -->
        <video
            :poster="poster"
            muted
            @contextmenu="preventEvent($event)"
            v-else-if="type === 'video' && src"
            :data-src="src"
            v-lazy-load="lazyLoadOptions"
            alt=""
            :loop="isLoop"
            :autoplay="isAutoPlay"
            :controls="controls"
            class="w-full h-full object-cover transform-scale-0 absolute left-0 top-0"
            :isDisableMouseover="isDisableMouseover"
            :controlslist="controlslist"
            disablePictureInPicture
            @canplaythrough="handleCanplaythrough"
            ref="videoInstance"
            @loadeddata="handleLoadeddata"
        ></video>

        <slot></slot>
    </div>
</template>
<script setup lang="ts">
import { ChatDetailItem } from '@/apis/publicBeta/api';
import LoadingComponent from './loading.vue';
const emits = defineEmits(['afterMounted']);
const loading = ref(true);
withDefaults(defineProps<{
    isLazy?: boolean;
    isNotAutoPause?: boolean;
    controlslist?: string;
    isLoadingError?: boolean;
    poster?: string;
    item?: ChatDetailItem;
    controls?: boolean;
    loadingWords?: string; // 文件加载文字提示
    isAutoPlay?: boolean;
    isLoop?: boolean;
    isDisableMouseover?: boolean;
    type: 'video' | 'img'; // 文件类型
    src: string; // 文件连接
    finishLoad?: Function; // 文件加载完成回调
}>(), { isLazy: true,controlslist: 'nodownload',isLoadingError: false,isLoop: true,isDisableMouseover: false, })
const lazyLoadOptions = computed(() => ({
    src: __props.src,
    isLazy: __props.isLazy,
}));
const preventEvent = (e: any) => {
    e.preventDefault();
};
const videoInstance = ref();
const imgInstance = ref();
const gridInstance = ref();
const handleLoadeddata = (e: any) => {
    __props.finishLoad && __props.finishLoad(gridInstance, e.target, __props.type, __props.src);
};
// 视频加载完成
const handleCanplaythrough = (e: any) => {
    loading.value = false;
    e.target.style.transform = 'scale(1)';
    if (__props.isAutoPlay) {
        playVideo('play');
    }
};
watchEffect(() => {
    if (imgInstance.value) {
        if (imgInstance.value.complete) {
            loadImg(imgInstance.value);
        } else {
            imgInstance.value.onload = () => {
                loadImg(imgInstance.value);
            };
        }
    }
});
// 图片加载完成
const loadImg = (instance: any) => {
    instance.style.transform = 'scale(1)';
    __props.finishLoad && __props.finishLoad(gridInstance, instance, __props.type);
};
// 鼠标悬浮播放视频
const playVideo = (type: string) => {
    if (__props.isDisableMouseover) {
        return;
    }
    if (!__props.src || !videoInstance.value || (__props.isNotAutoPause && type === 'pause')) return;
    if (type === 'play') {
        videoInstance.value.play();
    } else {
        videoInstance.value?.pause();
    }
};
onMounted(() => {
    emits('afterMounted');
});
defineExpose({ gridInstance, item: __props.item, videoInstance });
</script>

<style lang="scss" scoped>
video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 8px;
    // /* 或使用 'contain' 根据需求选择 */
    /* 确保视频不受额外的显示影响 */
    z-index: 2;
    /* 确保视频在最上层，或者调整为合适的值 */
}

video::-webkit-media-controls-button-panel {
    display: none;
}

// video::-webkit-media-controls-current-time-display {
//     // display: none;
// }
//剩余时间
// video::-webkit-media-controls-time-remaining-display {
//     // display: none;
// }
// video::-webkit-media-controls-play-button,
//video::-webkit-media-controls-volume-slider,
// video::-webkit-media-controls-mute-button,
video::-webkit-media-controls-fullscreen-button {
    display: none;
}

// //进度条
// video::-webkit-media-controls-timeline {
// }
</style>
